"use client";

import React, { useState } from "react";
import { Landmark, Award, Star, Users, Shield, Building2, GraduationCap, Flower2 } from "lucide-react";
import { Button } from "@/components/ui/button";
const categories = [{
  id: 1,
  title: "Tokoh Pendiri",
  desc: "Tokoh yang berperan mendirikan Pemuda Pancasila",
  icon: Landmark
}, {
  id: 2,
  title: "Ketua Umum",
  desc: "Ketua Umum MPN dari masa ke masa",
  icon: Award
}, {
  id: 3,
  title: "Tokoh Nasional",
  desc: "Tokoh berpengaruh di tingkat nasional",
  icon: Star
}, {
  id: 4,
  title: "Senior Organisasi",
  desc: "Senior berpengalaman dalam organisasi",
  icon: Users
}, {
  id: 5,
  title: "Anggota Kehormatan",
  desc: "Anggota yang diberi gelar kehormatan",
  icon: Shield
}, {
  id: 6,
  title: "Kader di Lembaga Negara",
  desc: "Kader Pemuda Pancasila di lembaga negara",
  icon: Building2
}, {
  id: 7,
  title: "MPO & Dewan Pakar",
  desc: "Majelis Pertimbangan dan Dewan Pakar",
  icon: GraduationCap
}, {
  id: 8,
  title: "Tokoh yang Telah Wafat",
  desc: "Tokoh yang telah berpulang dan berjasa bagi organisasi",
  icon: Flower2
}];
export default function CategoryFilterGrid() {
  const [activeCategory, setActiveCategory] = useState<number | null>(null);
  const handleCategoryClick = (id: number) => {
    setActiveCategory(id === activeCategory ? null : id);
    console.log(`Filtering by category: ${id}`);
  };
  return <section id="categoryfiltergrid" className="w-full bg-background py-8 md:py-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-6 border-b border-border/50 pb-3">
          <h1 className="font-default text-sm font-bold uppercase tracking-wider text-primary md:text-base">
            Kategori Tokoh & Senior Nasional
          </h1>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
          {categories.map((category, index) => {
          return <Button key={category.id} data-index={index} variant="outline" onClick={() => handleCategoryClick(category.id)} className={`zona-pp-grid-category group flex h-full w-full flex-col items-center gap-0 rounded-xl border border-border bg-card p-4 text-center shadow-sm transition-all hover:border-primary hover:shadow-md focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-ring/50 ${activeCategory === category.id ? "border-primary ring-2 ring-primary/20" : ""}`}>
                <category.icon className="h-8 w-8 text-primary mb-3" />
                <h3 className="font-default mb-1.5 text-xs font-bold whitespace-normal leading-tight text-foreground md:text-sm">
                  {category.title}
                </h3>
                <p className="whitespace-normal text-[10px] leading-snug text-muted-foreground md:text-xs">
                  {category.desc}
                </p>
              </Button>;
        })}
        </div>
      </div>
    </section>;
}